import { makeStyles } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    marginBottom: theme.spacing(6)
  },
  generalGroupHeader: {
    color: theme.palette.main
  },
  generalGroupHeaderWrapper: {
    width: '100%'
  },
  divider: {
    backgroundColor: theme.palette.gray.superLight,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3)
  }
}));
